export default {
    'Features': '產品介紹',
    'Solutions': '功能特點',
    'Contact': '聯絡方式',
    'Partner': '合作夥伴',
    'Download': '下載專區',
    'FAQ': '常見問題',
    'Freetrial': '申請試用',
    'locale.en': '英文',
    'locale.zh-TW': '繁體中文',
    'locale.zh-CN': '簡體中文'
}